import React, { useState, useEffect, useContext } from "react";

import { getComments } from "../../../services/tribe";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import MobileCommentModal from "../mobile-comment-modal/mobileCommentModal";
import ModalApprove from "../../atoms/modal-approve/modalApprove";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import DefaultImage from "../../../assets/images/not-found/03-SIN-LOGO.svg";
import GlobalContext from "../../../contexts/globalContext";

import "./makeComment.scss";

declare var gigya: any;

interface MakeCommentInter {
  referenciaContenido: ReferenciaContenido;
  showTitle?: boolean;
}

const MakeComment = (props: MakeCommentInter) => {
  const { document, window } = useBrowserMode();
    const { gigyaContext: { gigyaAccount } } = useContext(GlobalContext);

  const [userInput, setUserInput] = useState<any>("");
  const [imageInput, setImageInput] = useState<any>(null);
  const [showMobileComment, setShowMobileComment] = useState(false);
  const [modalPublish, setModalPublish] = useState(false);
  const [cdcInfo, setCdcInfo] = useState<any>();
  const [urlImage, setUrlImage] = useState<any>(DefaultImage);
  const [totalComments, setTotalComments] = useState<any>(0);

  useEffect(() => {
    if (typeof props.referenciaContenido !== "undefined") {
      const getCommentsFn = async () => {
        const response: any = await getComments(
          props.referenciaContenido.autoresArticulo[0],
          gigyaAccount?.profile && gigyaAccount?.profile.email,
          gigyaAccount?.profile.firstName +
            " " +
            gigyaAccount?.profile.lastName || "",
          gigyaAccount?.UID || ""
        );
        setTotalComments(response.comments.length);
      };
      getCommentsFn();
    }
  }, [gigyaAccount?.UID]);

  const onChangeHandler = (event) => {
    const { value } = event.target;

    if (userInput && userInput.length < 300) setUserInput(value);
    else setUserInput(value.slice(0, 300));
  };

  useEffect(() => {
    gigya.accounts.getAccountInfo({
      callback: (response) => {
        setCdcInfo(response);
        if (response.profile && response.profile.photoURL) {
          setUrlImage(response.profile.photoURL);
        }
      },
    });
  }, []);

  return (
    <div className="m-make-comment" id="make-comment">
      <ModalApprove
        onClose={() => {
          setModalPublish(false);
          setUserInput("");
          window.location.reload();
        }}
        open={modalPublish}
      />

      {props.showTitle && (
        <div className="m-make-comment__quantity">
          <h4 className="m-make-comment__quantity-number">
            {totalComments} comentarios
          </h4>
        </div>
      )}

      <div className="m-make-comment__container">
        <div className="m-make-comment__container-profile">
          <img
            src={urlImage}
            alt={
              cdcInfo?.profile
                ? `Foto ${cdcInfo?.profile.firstName} ${cdcInfo?.profile.lastName}`
                : "Foto usuario"
            }
          />
        </div>

        <div
          className="m-make-comment__container-input"
          onClick={
            cdcInfo && cdcInfo.errorCode !== 0
              ? () => {
                  document.getElementsByClassName("a-login__title")[0].click();
                }
              : () => {
                  setShowMobileComment(true);
                }
          }
        >
          <input
            type="text"
            placeholder="Comenta algo..."
            className="m-make-comment__container-input__text"
            onChange={onChangeHandler}
            value={userInput}
            readOnly={true}
          />

          <div
            className={`m-make-comment__container-input__btn`}
            onClick={
              cdcInfo && cdcInfo.errorCode !== 0
                ? () => {
                    document
                      .getElementsByClassName("a-login__title")[0]
                      .click();
                  }
                : () => {
                    setShowMobileComment(true);
                  }
            }
          >
            <p className="icon-paper-plane1"></p>
            <p className="m-make-comment__container-input__btn-button hide-on-mobile">
              COMENTAR
            </p>
          </div>
        </div>
      </div>

      {showMobileComment ? (
        <MobileCommentModal
          idConversation={props.referenciaContenido?.autoresArticulo[0]}
          imageInput={imageInput}
          setImageInput={setImageInput}
          handlerInput={onChangeHandler}
          closeModal={() => {
            setShowMobileComment(false);
            setUserInput("");
            setImageInput(null);
          }}
          closeModalPublish={() => {
            setShowMobileComment(false);
            setModalPublish(true);
            setImageInput(null);
          }}
          urlImage={
            cdcInfo && cdcInfo.profile.photoURL
              ? cdcInfo.profile.photoURL
              : null
          }
        />
      ) : null}
    </div>
  );
};

export default MakeComment;
